(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8732],{

/***/ 3936:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/covid-policy",
      function () {
        return __webpack_require__(3898);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6240:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Topbanner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9262);
/* harmony import */ var _Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_1__);


function Topbanner(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
            className: (_Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_1___default().top_banner),
            style: {
                backgroundImage: "url(".concat(props.bgImage, ")")
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_Topbanner_module_scss__WEBPACK_IMPORTED_MODULE_1___default().banner_text),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "container common_title text-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        children: props.title
                    })
                })
            })
        })
    });
}


/***/ }),

/***/ 3898:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ CovidPolicy; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _styles_pages_Home_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(256);
/* harmony import */ var _styles_pages_Home_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_pages_Home_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _components_Topbanner_Topbanner__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6240);




function CovidPolicy() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "The Twin Towers Hotel in Kufri, Shimla| Covid Policy Page"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: " Explore our COVID-19 policies, hotel arrival procedures, elevated guest services, and meticulous sanitization protocols at The Twin Towers Hotel."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "icon",
                        href: "/favicon.svg"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Topbanner_Topbanner__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                bgImage: "/images/terms-banner.png",
                title: "COVID Policy"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "".concat((_styles_pages_Home_module_scss__WEBPACK_IMPORTED_MODULE_3___default().privacy_policy), " common_padding"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "common_title",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                children: "Policies & safety measures for COVID are below:"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: "Reservations and Admission:"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        children: "Admission to The Twin Towers Hotel  is subject to submission of Covid final vaccination certificate (vaccination validity is 280 days from the date of last vaccination)"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        children: "If unvaccinated, partially vaccinated, or vaccination is outside of the validity period, guests must submit an RT-PCR test conducted not earlier than 72 hours from the time of arrival at The Twin Towers Hotel."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        children: "Guests are advised to also independently verify the updated regulations as listed on the Indian government and Himachal Pradesh State government websites and take appropriate action to adhere to these guidelines. The Twin Towers Hotel does not take any responsibility or liability for changes in these regulations."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                children: "Arrival at Hotel:"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        children: "Hotel cars are sanitized using safe sanitizing procedures before each trip."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        children: "Sanitising products are available in the car."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        children: "Automatic hand sanitizer is available at locations across the premises."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                children: "Guest Services and Sanitization Measures:"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        children: "All rooms surfaces and public areas are sanitized regularly with safe disinfecting chemicals"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        children: "After a thorough cleaning of the room, all the areas and surfaces are carefully sanitized"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        children: "All ventilation and air-conditioning units in rooms are cleaned and sanitized frequently using FOG machines."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        children: "All amenities, linen, and glassware used in rooms are sanitized High-temperature washing of all crockery and silverware used in restaurant and other dining venues."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                children: "The Twin Towers Hotel Team :"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        children: "All  staff members wear a Face Mask while on hotel premises"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        children: "Daily thermal check for all staff members is done along with regular health screenings"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        children: "All ventilation and air-conditioning units in rooms are cleaned and sanitized frequently using FOG machines."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        children: "Out staff members are fully vaccinated"
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
}


/***/ }),

/***/ 9262:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"top_banner":"Topbanner_top_banner__iVW4z","banner_text":"Topbanner_banner_text__wm4dg"};

/***/ }),

/***/ 256:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"home_banner":"Home_home_banner__kArgw","banner_text":"Home_banner_text__nh89y","banner_text_con":"Home_banner_text_con__Jogsr","videobanner":"Home_videobanner__Tkj0g","video_bg":"Home_video_bg__qf_ah","hyperlink_button":"Home_hyperlink_button__y667M","single_hotel_search_form_container":"Home_single_hotel_search_form_container__HqA9G","home_banner_image":"Home_home_banner_image__t3akK","mobiel_home_banner_image":"Home_mobiel_home_banner_image__GUcAt","banner_video":"Home_banner_video__SddjS","banner_slider_wrapper":"Home_banner_slider_wrapper__UTLDE","slick_slide":"Home_slick_slide__qJU2c","slick_slide_image":"Home_slick_slide_image__hhGEg","slick_slide_text":"Home_slick_slide_text__O67as","slick-prev":"Home_slick-prev__4656Z","slick-next":"Home_slick-next__1kKST","booking_sec":"Home_booking_sec__HpePc","booking_cont":"Home_booking_cont__fMu_2","booking_col":"Home_booking_col__dOC3d","button_col":"Home_button_col__bFrbD","check_now_btn":"Home_check_now_btn__mHeYn","room_con":"Home_room_con__yiOP5","room_left":"Home_room_left__idckC","room_center":"Home_room_center__k4vSt","room_right":"Home_room_right__erFsr","room_right_bottom":"Home_room_right_bottom__kmBTr","right_bottom_text":"Home_right_bottom_text__mvi4g","button_sec":"Home_button_sec__MdG6_","hall_sec":"Home_hall_sec__fTUX9","image_sec":"Home_image_sec__tFNpX","image_sec_left":"Home_image_sec_left__werHr","conference_btn":"Home_conference_btn__XZpN3","image_overlay":"Home_image_overlay__Cp9qu","activities_sec":"Home_activities_sec__ARKi1","activities_slider":"Home_activities_slider___q9lq","activity_child":"Home_activity_child__uN8Qi","activity_bg_image":"Home_activity_bg_image__ugYWi","activity_overlay":"Home_activity_overlay__t5zMy","explore_btn":"Home_explore_btn__6MzO_","help_sec":"Home_help_sec__7Rilk","help_sec_child":"Home_help_sec_child__SIt9r","testimonial_sec":"Home_testimonial_sec__B_HiR","background_image":"Home_background_image__Vo5NE","testimonial":"Home_testimonial__QHdb5","testi_left":"Home_testi_left__0C7fk","testi_right":"Home_testi_right__QAzWv","blogs_sec":"Home_blogs_sec__IzPka","blogs":"Home_blogs__oH2o4","single_blog_parent":"Home_single_blog_parent__Zq2Tg","all_blog_image":"Home_all_blog_image___i_Z2","all_blog_content":"Home_all_blog_content__ZBhKT","privacy_policy":"Home_privacy_policy__Z3_uX"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(3936); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);